import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  template: `
    @if (data?.length) {
      <textarea> {{ data[0] }} </textarea>
    }
    `,
  styleUrls: ['./textarea.component.scss'],
})
export class TextareaComponent {
  @Input()
  data: any;

  constructor() {}
}
